/* eslint-disable */
const mutations = {
  updateIsLoading(state, { isLoading }) {
    state.isLoading = isLoading;
  },

  setProduct(state, { product }) {
    state.data = product;
  },

  updateProduct(state, { product }) {
    state.data = {
      ...state.data,
      ...product,
    };
  },

  updateProductCategories(state, { categories }) {
    state.data = {
      ...state.data,
      categories,
    };
  },

  updateProductPhotos(state, { photos }) {
    state.data.photos = photos;
  },
};

export default mutations;
